import React, { useMemo, useState, useEffect } from 'react';
import Chart from "react-apexcharts";

export const TopVendedores = ({ zonasSupervisor = [], multipleTops, topData, topData2, topData3 }) => {
  // Detecta si estamos en desktop (>= 768px o el valor que prefieras)
  const [isDesktop, setIsDesktop] = useState(typeof window !== 'undefined' ? window.innerWidth >= 768 : true);

  useEffect(() => {
    const onResize = () => setIsDesktop(window.innerWidth >= 768);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  // ---------- helpers para mobile ----------
  const calcMinWidth = (chart) => {
    if (!chart) return '100%';
    const count = chart.series?.[0]?.data
      ? chart.series[0].data.length
      : (chart.options?.xaxis?.categories?.length || 0);

    // px por categoría en mobile para que no se apachurre
    const pxPer = 110;
    const required = Math.max(count * pxPer, 320);

    // cap: 90% del viewport width (no exagerar)
    const cap = Math.max(320, Math.floor((typeof window !== 'undefined' ? window.innerWidth : 1200) * 0.9));
    const final = Math.min(required, cap);

    return `${final}px`;
  };

  const buildMobileOptions = (baseOptions = {}) => {
    const barHeightMobile = '60%';
    return {
      ...baseOptions,
      chart: {
        ...(baseOptions.chart || {}),
        toolbar: { show: false },
        height: 360
      },
      dataLabels: { enabled: false },
      legend: { show: false },
      plotOptions: {
        ...(baseOptions.plotOptions || {}),
        bar: {
          ...(baseOptions.plotOptions?.bar || {}),
          horizontal: true,
          barHeight: barHeightMobile,
          borderRadius: 8
        }
      },
      xaxis: {
        ...(baseOptions.xaxis || {}),
        labels: {
          ...(baseOptions.xaxis?.labels || {}),
          trim: true,
          hideOverlappingLabels: true,
          maxHeight: 60,
          rotate: -45
        }
      },
      tooltip: {
        y: {
          formatter: (v) => {
            if (v === null || v === undefined) return '0';
            const n = Number(v);
            if (Number.isNaN(n)) return String(v);
            return n.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
          }
        }
      }
    };
  };

  // ------------- RENDER -------------
  // Si es desktop -> render EXACTAMENTE tu diseño original
  if (isDesktop) {
    return (
      <>
        <div className="container-fluid px-2">
          {
            (multipleTops) ?
              <>
                <div className="row">
                  <div className="col bg-white drop-shadow-card rounded">
                    <h4 className="text-center text-belmeny fst-italic mt-3">Top vendedores zona: {zonasSupervisor?.[0]?.Sector ?? ''}</h4>
                    {topData?.series ? (
                      <Chart
                        options={topData.options}
                        series={topData.series}
                        type="bar"
                        width="75%"
                        className="d-flex align-center justify-content-center"
                      />
                    ) : <div className="text-center py-4 text-muted">No hay datos</div>}
                  </div>
                </div>

                <div className="row mt-3">
                  <div className="col bg-white drop-shadow-card rounded">
                    <h4 className="text-center text-belmeny fst-italic mt-3">Top vendedores zona: {zonasSupervisor?.[1]?.Sector ?? ''}</h4>
                    {topData2?.series ? (
                      <Chart
                        options={topData2.options}
                        series={topData2.series}
                        type="bar"
                        width="75%"
                        className="d-flex align-center justify-content-center"
                      />
                    ) : <div className="text-center py-4 text-muted">No hay datos</div>}
                  </div>
                </div>

                <div className="row mt-3">
                  <div className="col bg-white drop-shadow-card rounded">
                    <h4 className="text-center text-belmeny fst-italic mt-3">Top vendedores zona: {zonasSupervisor?.[2]?.Sector ?? ''}</h4>
                    {topData3?.series ? (
                      <Chart
                        options={topData3.options}
                        series={topData3.series}
                        type="bar"
                        width="75%"
                        className="d-flex align-center justify-content-center"
                      />
                    ) : <div className="text-center py-4 text-muted">No hay datos</div>}
                  </div>
                </div>
              </> :
              <>
                <div className="row d-flex align-middle justify-content-center">
                  <div className="col w-75 bg-white drop-shadow-card">
                    <h4 className="text-center text-belmeny fst-italic mt-3">Top vendedores zona {zonasSupervisor?.[0]?.Sector ?? ''}</h4>
                    {topData?.series ? (
                      <Chart
                        options={topData.options}
                        series={topData.series}
                        type="bar"
                        width="75%"
                        className="d-flex align-middle justify-content-center"
                      />
                    ) : <div className="text-center py-4 text-muted">No hay datos</div>}
                  </div>
                </div>
              </>
          }
        </div>
      </>
    );
  }

  // Si no es desktop -> mobile friendly layout
  return (
    <>
      {/* CSS embebido para mobile-only tweaks */}
      <style>{`
        .topvendedores-mobile .chart-scroll {
          overflow-x: auto;
          -webkit-overflow-scrolling: touch;
        }
        .topvendedores-mobile .chart-inner {
          display: block;
        }
        .topvendedores-mobile .chart-card {
          padding: 10px;
          margin-bottom: 12px;
        }
        .topvendedores-mobile h5, .topvendedores-mobile h4 {
          font-size: 1rem;
        }
      `}</style>

      <div className="container-fluid px-2 topvendedores-mobile">
        {
          (multipleTops) ? (
            <>
              {/* Zona 1 */}
              <div className="row">
                <div className="col bg-white drop-shadow-card rounded chart-card p-2">
                  <h5 className="text-center text-belmeny fst-italic mt-2">Top vendedores zona: {zonasSupervisor?.[0]?.Sector ?? '-'}</h5>
                  {topData?.series ? (
                    <div className="chart-scroll">
                      <div className="chart-inner" style={{ minWidth: calcMinWidth(topData) }}>
                        <Chart
                          options={buildMobileOptions(topData.options)}
                          series={topData.series}
                          type="bar"
                          width="100%"
                          height={360}
                        />
                      </div>
                    </div>
                  ) : <div className="text-center text-muted small py-3">No hay datos</div>}
                </div>
              </div>

              {/* Zona 2 */}
              <div className="row">
                <div className="col bg-white drop-shadow-card rounded chart-card p-2">
                  <h5 className="text-center text-belmeny fst-italic mt-2">Top vendedores zona: {zonasSupervisor?.[1]?.Sector ?? '-'}</h5>
                  {topData2?.series ? (
                    <div className="chart-scroll">
                      <div className="chart-inner" style={{ minWidth: calcMinWidth(topData2) }}>
                        <Chart
                          options={buildMobileOptions(topData2.options)}
                          series={topData2.series}
                          type="bar"
                          width="100%"
                          height={360}
                        />
                      </div>
                    </div>
                  ) : <div className="text-center text-muted small py-3">No hay datos</div>}
                </div>
              </div>

              {/* Zona 3 */}
              <div className="row">
                <div className="col bg-white drop-shadow-card rounded chart-card p-2">
                  <h5 className="text-center text-belmeny fst-italic mt-2">Top vendedores zona: {zonasSupervisor?.[2]?.Sector ?? '-'}</h5>
                  {topData3?.series ? (
                    <div className="chart-scroll">
                      <div className="chart-inner" style={{ minWidth: calcMinWidth(topData3) }}>
                        <Chart
                          options={buildMobileOptions(topData3.options)}
                          series={topData3.series}
                          type="bar"
                          width="100%"
                          height={360}
                        />
                      </div>
                    </div>
                  ) : <div className="text-center text-muted small py-3">No hay datos</div>}
                </div>
              </div>
            </>
          ) : (
            <div className="row">
              <div className="col bg-white drop-shadow-card rounded chart-card p-2">
                <h5 className="text-center text-belmeny fst-italic mt-2">Top vendedores zona: {zonasSupervisor?.[0]?.Sector ?? '-'}</h5>
                {topData?.series ? (
                  <div className="chart-scroll">
                    <div className="chart-inner" style={{ minWidth: calcMinWidth(topData) }}>
                      <Chart
                        options={buildMobileOptions(topData.options)}
                        series={topData.series}
                        type="bar"
                        width="100%"
                        height={360}
                      />
                    </div>
                  </div>
                ) : <div className="text-center text-muted small py-3">No hay datos</div>}
              </div>
            </div>
          )
        }
      </div>
    </>
  );
};
